module.exports = __webpack_public_path__ + "img/722f1a7.png";